import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { getSliders } from '../../actions/home';

export const Banner = () => {
  const [sliders, setSliders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isVisible, setIsVisible] = useState(true); // Estado para controlar la visibilidad del banner

  // Definir sliderId que se desea mostrar
  const [selectedSliderId, setSelectedSliderId] = useState(1); // Cambia el 1 por el id que desees mostrar

  useEffect(() => {
    const loadSliders = async () => {
      try {
        const result = await getSliders();
        setSliders(result);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    loadSliders();
  }, []);

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>Error: {error}</div>;

  // Filtra sliders para encontrar el que tenga el sliderId deseado
  const selectedSlider = sliders.find(s => s.sliderId === selectedSliderId);

  // Función para cerrar el banner
  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <>
      {isVisible && selectedSlider ? (
        <div className="banner-container">  
          <Link to={`/catalogo-producto/${selectedSliderId}`}>
            <img
              key={selectedSlider.sliderId}
              src={selectedSlider.sliderCabeceraXsUrl}
              alt="imagen slider xs"
              className="img-responsive img-movil"
            />
          </Link>

          <Link to={`/catalogo-producto/${selectedSliderId}`}>
            <img
              key={selectedSlider.sliderId}
              src={selectedSlider.sliderCabeceraLgUrl}
              alt="imagen slider lg"
              className="img-responsive img-desktop"
            />
          </Link>

          {/* Div de cerrar */}
          <div className="close-button" onClick={handleClose}>
            &times; {/* Esto representa la "X" */}
          </div>
        </div>
      ) : (
        null
      )}
    </>
  );
};